import {gql} from "@apollo/client";

export default gql`
  mutation enableManager($managerId: ID!, $employerId: ID!) {
    enableManager(managerId: $managerId, employerId: $employerId)
  }
`;
